import React, {useEffect, useState} from 'react';
import {Pagination, Select, Table} from "antd";
import trashIcon from "../../images/bin.svg"
import editIcon from "../../images/Group 28.svg"
import UserForm from "./UserForm";
import Loader from "../ApplicationComponent/Loader";
import {getAllUsers} from "../../redux-store/users";
import {useDispatch, useSelector} from "react-redux";
import {
    getAllInstallationsWithoutPag,
    getAllUsersItem,
    getUsersLoading,
    getUsersPagination,
    installationsLoad
} from "../../redux-store/selectors";
import api from "../../api/apiInterceptor";
import UserDeleteConfirmModal from "./UserDeleteConfirmModal";
import {getInstallationsWithoutPag} from "../../redux-store/installations";
import {FaCheck} from "react-icons/fa";
import SearchComponent from "../SearchComponent";

const {Option} = Select

const Users = () => {

    const dispatch = useDispatch();
    const usersSelector = useSelector(getAllUsersItem)
    const usersLoading = useSelector(getUsersLoading)
    const {total, pageSize, currentPage} = useSelector(getUsersPagination);
    const installationLoader = useSelector(installationsLoad);
    const installations = useSelector(getAllInstallationsWithoutPag);

    const [searchValue, setSearchValue] = useState([])
    const [selectData, setSelectData] = useState([]);
    const [selectedValue, setSelectedValue] = useState(null);
    const [showModal, setShowModal] = useState(false)
    const [editId, setEditId] = useState(null)
    const [deleteId, setDeleteId] = useState(null)
    const [showDeleteModal, setShowDeleteModal] = useState(false)

    const confirmDelete = async () => {
        await api.delete(`/api/users/${deleteId}`)
        setShowDeleteModal(false)
        dispatch(getAllUsers({}))
    }

    const handleEdit = (id) => {
        setEditId(id)
        setShowModal(true)
    }

    const handleDelete = (id) => {
        setDeleteId(id)
        setShowDeleteModal(true)
    }

    const columns = [
        {
            title: 'Username',
            dataIndex: 'username',
            key: 'username',
            sorter: (a, b) => a.username.localeCompare(b.username)
        },
        {
            title: 'First name',
            dataIndex: 'firstName',
            key: 'firstName',
            sorter: (a, b) => a.firstName.localeCompare(b.firstName)
        },
        {
            title: 'Last name',
            dataIndex: 'lastName',
            key: 'lastName',
            sorter: (a, b) => a.lastName?.localeCompare(b.lastName)
        },
        {
            title: 'Role',
            dataIndex: 'role',
            key: 'role',
            sorter: (a, b) => a.role.localeCompare(b.role)
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'FCM Token',
            dataIndex: 'fcmTokenSet',
            key: 'fcmTokenSet',
            render: (item) => {
                return <>
                    {item === true ? <FaCheck/> : ""}
                </>
            }
        },
        {
            title: 'Phone number',
            dataIndex: 'phoneNumber',
            key: 'phoneNumber',
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            render: (item, row) => {
                return <>
                    <img onClick={() => handleEdit(row.id)} src={editIcon} alt={"Edit Icon"}
                         className={"m-right cursor-button"}/>
                    <img onClick={() => handleDelete(row.id)} src={trashIcon} alt={"Trash Icon"}
                         className={"w-icons cursor-button"}/>
                </>
            }
        }
    ]

    useEffect(() => {
        dispatch(getInstallationsWithoutPag());
    }, []);

    useEffect(() => {
        dispatch(getAllUsers({}))
    }, [])

    useEffect(() => {
        const selectedData = installations.map((item) => {
            return (<Option key={item.id} value={item.id}>{item.name}</Option>)
        });
        setSelectData(selectedData)
    }, [installations]);

    const handleInstallationSelectChange = selectedValue => {
        setSelectedValue(selectedValue);
        dispatch(getAllUsers({usersId: selectedValue?.value ? selectedValue.value : "", search: searchValue}));
    }

    const handleSearch = (searchVal) => {
        setSearchValue(searchVal)
        dispatch(getAllUsers({search: searchVal, usersId: selectedValue?.value ? selectedValue.value : ""}));
    }

    const handlePageChange = (newPage) => {
        dispatch(getAllUsers({
            page: newPage - 1,
            pageSize,
            usersId: selectedValue?.value ? selectedValue.value : "",
            search: searchValue
        }));
    }

    return (
        <div className={"container-fluid pt-3 p-side"}>
            <div className={"row pt-3 pb-3 bottom-line"}>
                <div className={"col-12 col-md-6 col-lg-6 col-xl-6"}>
                    <div className="d-flex align-items-center installation-select">
                        <label className="home-page-label">Korisnici</label>
                        <div className="col-7 col-md-7 col-lg-5 col-xl-4 ant-select-installations">
                            <Select labelInValue style={{width: "200px"}} loading={installationLoader}
                                    disabled={installationLoader} allowClear placeholder={"Odaberite"}
                                    onChange={handleInstallationSelectChange} value={selectedValue}>
                                {selectData}
                            </Select>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"row pb-3 pt-3"}>
                <div className={"col-12 text-right"}>
                    <button className={"btn btn-main"} onClick={() => {
                        setShowModal(true)
                    }}>Dodaj korisnika
                    </button>
                    <div className={"col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3"}>
                        <SearchComponent handleSearchSubmit={handleSearch}/>
                    </div>
                </div>
            </div>
            <div className={"row"}>
                <div className={"col-12"}>
                    {usersLoading ? <Loader/> : <Table showSorterTooltip={false}
                                                       columns={columns}
                                                       dataSource={usersSelector}
                                                       pagination={false}
                                                       size="small"
                                                       rowKey="id"
                                                       scroll={{
                                                           x: 900,
                                                           //y: 450,
                                                       }}/>}
                </div>
            </div>
            <div className={"row text-right pt-3"}>
                <div className={"col-12"}>
                    {usersLoading ? <Loader/> : <Pagination defaultCurrent={1}
                                                            current={currentPage + 1}
                                                            total={total}
                                                            showSizeChanger={false}
                                                            onChange={handlePageChange}/>}
                </div>
            </div>
            <UserForm showModal={showModal} setShowModal={setShowModal} editId={editId}
                      setEditId={setEditId} installationId={selectedValue?.value}/>
            <UserDeleteConfirmModal showModal={showDeleteModal} setShowModal={setShowDeleteModal}
                                    confirm={confirmDelete}/>
        </div>
    );
};

export default Users;
